document.querySelectorAll('.event-booking-wrapper').forEach(wrapper => {
  const nextBtn = wrapper.querySelector('[data-next]');
  const backBtn = wrapper.querySelector('[data-back]');
  const step1 = wrapper.querySelector('.event-step--date');
  const step2 = wrapper.querySelector('.event-step--qty');
  const monthLabel = wrapper.querySelector('[data-month-label]');
  const calendarBody = wrapper.querySelector('[data-calendar-body]');
  const summary = wrapper.querySelector('[data-event-summary]');
  const selectTime = wrapper.querySelector('.event-select select');
  const totalPriceEl = wrapper.querySelector('.js-total-price strong');


    let currentDate;

  const variants = window.__rawEventProductPdp[0].variants;
  let selectedVariantId = null;
  let selectedVariantPrice = 0;
  let quantity = 1;

   const urlVariantId = getUrlVariantId(); 
    if (urlVariantId) {
        const variant = variants.find(v => String(v.v_id) === urlVariantId);
        if (variant) {
            const variantDate = new Date(normalizeDate(variant.date));
            currentDate = new Date(variantDate.getFullYear(), variantDate.getMonth());
        } else {
            currentDate = new Date(); // fallback to current month
        }
    } else {
        currentDate = new Date(); // current month
    }

  // Normalize human-readable date
  function normalizeDate(humanDate) {
    if (!humanDate) return null;
    humanDate = humanDate.replace(/(\d+)(st|nd|rd|th)/, '$1');
    const dateObj = new Date(humanDate);
    if (isNaN(dateObj)) return null;
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, '0');
    const d = String(dateObj.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  const variantDates = variants.map(v => normalizeDate(v.date));

  function updateTotalPrice() {
    const total = (selectedVariantPrice || 0) * (quantity || 1);
    if (totalPriceEl) totalPriceEl.textContent = `$${total.toFixed(2)}`;
  }

  function renderCalendar(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();
    const prevLast = new Date(year, month, 0).getDate();

    monthLabel.textContent = date.toLocaleString('default', { month: 'long', year: 'numeric' });

    let days = '';
    for (let x = firstDay; x > 0; x--) days += `<td class="is-muted">${prevLast - x + 1}</td>`;
    for (let i = 1; i <= lastDate; i++) {
      const isoDate = `${year}-${String(month + 1).padStart(2,'0')}-${String(i).padStart(2,'0')}`;
      const cls = variantDates.includes(isoDate) ? 'is-available' : 'is-disabled';
      days += `<td data-day="${i}" class="${cls}">${i}</td>`;
      if ((i + firstDay) % 7 === 0) days += '</tr><tr>';
    }
    const remaining = (7 - ((firstDay + lastDate) % 7)) % 7;
    for (let j = 1; j <= remaining; j++) days += `<td class="is-muted">${j}</td>`;

    calendarBody.innerHTML = `<tr>${days}</tr>`;

    const availableCells = wrapper.querySelectorAll('.event-calendar__table td.is-available');

    if (availableCells.length === 0) {
      // No available dates
      selectTime.innerHTML = '<option disabled>No times available</option>';
      wrapper.querySelector(".event-select").classList.add("hidden")

      nextBtn.style.display = 'none'; // hide next/proceed button
      selectedVariantId = null;
      selectedVariantPrice = 0;
      updateTotalPrice();
      return;
    } else {
      nextBtn.style.display = ''; // show next/proceed button
      wrapper.querySelector(".event-select").classList.remove("hidden")
    }

    availableCells.forEach(td => {
      td.style.fontWeight = 'bold';
      td.addEventListener('click', () => {
        wrapper.querySelectorAll('.event-calendar__table td').forEach(c => c.classList.remove('is-selected'));
        td.classList.add('is-selected');
        
        document.querySelector(".js-error").classList.add("hidden")

        const selectedDay = td.getAttribute('data-day');
        const isoDate = `${year}-${String(month + 1).padStart(2,'0')}-${String(selectedDay).padStart(2,'0')}`;
        const sameDateVariants = variants.filter(v => normalizeDate(v.date) === isoDate);

        if (sameDateVariants.length > 0) {
          selectTime.innerHTML = sameDateVariants.map(v => {
            const disabled = v.available ? '' : 'disabled'; // disable if not available
            const label = `${v.time} / $${v.price}`;
            return `<option value="${v.v_id}" data-variant-id="${v.v_id}" data-price="${v.price}" ${disabled}>${label}</option>`;
          }).join('');

          const firstOption = selectTime.querySelector('option:not([disabled])');
          if (firstOption) {
            firstOption.selected = true;
            selectedVariantId = firstOption.dataset.variantId;
            selectedVariantPrice = parseFloat(firstOption.dataset.price || 0);
            changeInputValue(selectedVariantId);
            updateTotalPrice();
          } else {
            // If no available times, reset selection
            selectedVariantId = null;
            selectedVariantPrice = 0;
            changeInputValue(null);
            updateTotalPrice();
          }

          wrapper.querySelector(".event-select").classList.remove("hidden");
        } else {
          // No variants at all
          selectTime.innerHTML = '<option disabled>No times available</option>';
          wrapper.querySelector(".event-select").classList.add("hidden");
          selectedVariantId = null;
          selectedVariantPrice = 0;
          updateTotalPrice();
        }
      });
    });

    // Auto-select first available date if URL variant not present
    if (!getUrlVariantId()) {
      availableCells[0].click();
    }
  }

  function getUrlVariantId() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function autoSelectVariantFromUrl() {
    const urlVariantId = getUrlVariantId();
    if (!urlVariantId) return;

    const variant = variants.find(v => String(v.v_id) === urlVariantId);
    if (!variant) return;

    const dateIso = normalizeDate(variant.date);
    const timeVal = variant.v_id;

    wrapper.querySelectorAll('.event-calendar__table td.is-available').forEach(td => {
      const selectedDay = td.getAttribute('data-day');
      const cellIsoDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2,'0')}-${String(selectedDay).padStart(2,'0')}`;
      if (cellIsoDate === dateIso) td.click();
    });

    setTimeout(() => {
      const optionToSelect = selectTime.querySelector(`option[value="${timeVal}"]`);
      if (optionToSelect) {
        optionToSelect.selected = true;
        selectedVariantId = optionToSelect.dataset.variantId;
        selectedVariantPrice = parseFloat(optionToSelect.dataset.price || 0);
        changeInputValue(selectedVariantId);
        updateTotalPrice();
      }
    }, 50);
  }

  renderCalendar(currentDate);
  autoSelectVariantFromUrl();

  selectTime.addEventListener('change', e => {
    const option = e.target.selectedOptions[0];
    selectedVariantId = option ? option.dataset.variantId : null;
    selectedVariantPrice = option ? parseFloat(option.dataset.price || 0) : 0;
    changeInputValue(selectedVariantId);
    updateTotalPrice();
  });

  const quantityInput = wrapper.querySelector('.js-event-input');
  if (quantityInput) {
    quantityInput.addEventListener('change', e => {
      quantity = parseInt(e.target.value) || 1;
      updateTotalPrice();
    });
  }

  wrapper.querySelector('.event-calendar__nav--prev').addEventListener('click', () => {
    currentDate.setMonth(currentDate.getMonth() - 1);
    renderCalendar(currentDate);
    autoSelectVariantFromUrl();
  });

  wrapper.querySelector('.event-calendar__nav--next').addEventListener('click', () => {
    currentDate.setMonth(currentDate.getMonth() + 1);
    renderCalendar(currentDate);
    autoSelectVariantFromUrl();
  });

  nextBtn.addEventListener('click', () => {
    const selected = wrapper.querySelector('.event-calendar__table td.is-selected');
    if (!selected) return document.querySelector(".js-error").classList.remove("hidden");
    if (!selectedVariantId) return document.querySelector(".js-error").classList.remove("hidden");
    changeInputValue(selectedVariantId);

    step1.classList.add('hidden');
    step2.classList.remove('hidden');
    step2.classList.add('fade');

    const monthYear = monthLabel.textContent;
    const selectedTimeLabel = selectTime.selectedOptions[0]?.textContent.split('/')[0] || '';
    summary.textContent = `${monthYear} ${selected.textContent} ${selectedTimeLabel}`;
  });

  backBtn.addEventListener('click', () => {
    step2.classList.add('hidden');
    step1.classList.remove('hidden');
    step1.classList.add('fade');
  });

});



function changeInputValue(selectedVariantId) {
    const input = document.querySelector(".js-qty-calendar"); 
    if (input) {
        input.value = selectedVariantId;
        console.log("Input updated with Variant ID:", selectedVariantId);
    } else {
        console.warn("Input element not found");
    }
}

const input = document.querySelector(".js-quantity-input"); 
const eventInput = document.querySelector(".js-event-input");

if (eventInput && input) {
  eventInput.addEventListener("change", () => {
    const value = eventInput.value;
    input.value = value;
    console.log("Quantity input updated:", value);
  });
} else {
  console.warn("Inputs not found");
}



const eventBtnBook = document.querySelector(".js-event-btn-book");
const defaultButton = document.querySelector(".js-calendar-add-to-cart");
eventBtnBook.addEventListener("click", () => {
  defaultButton.click();
});








